<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oO6ciz/tc-custom/buylink_9781982113308_cover.jpg?1718106504099?1730521357455" alt="This image is the cover for the book Infection, Star Trek: The Next Generation"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Infection, Star Trek: The Next Generation
      </h1>
      <p class="bookDescription body article font2">
        <b>A <i>Star Trek </i>adventure set during <i>The Original Series </i>era from bestselling author</b><b> John Gregory</b><b>Betancourt</b><b>!</b><br/><br/>Like the twisted strands of mutant chromosomes, an insidious alien conspiracy winds its way through the entire Alpha Quadrant, just as it stretches across several years of Starfleet history—beginning near the very start of Captain Picard's command of the <i>Starship Enterprise™!</i><br/><br/>It is only the first year of the <i>U.S.S. Enterprise™</i>-D's ongoing mission when a virulent epidemic strikes the populace of Archaria III, endangering the lives of thousands and provoking acts of mob violence against those believed responsible for the spread of the disease. While Data and Natasha Yar team up to uncover the true origins of the virus, Dr. Crusher finds that the implacable sickness resists all her efforts to find a cure. The desperate quest for a cure becomes even more urgent when Deanna Troi succumbs to the dreaded plague...again and again.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Gregory Betancourt
      </h2>
      
      <p class="authorDescription body article">John Gregory Betancourt is the bestselling author of more thirty books, including several&#160;<I>Star Trek </I>novels and the Dawn of Amber trilogy.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gallery
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7e26ae0f